<template>
  <div>
    <div class="flex justify-content-end gap-2 py-4">
      <Button label="Add Results" :class="[isInstitute ? 'yellow-button-small' : 'teal-button-small']" @click="$emit('add-results')" />
    </div>
    <div class="grid-container">
      <div v-for="(result, index) in results" :key="index">
        <Card class="Card p-4 h-full">
          <template #content>
            <div class="flex flex-column align-items-center justify-content-center gap-2 text-sm">
              <div class="flex justify-content-between align-items-start w-full" style="min-height: 2.5em;">
                <span class="Paragraph-Medium text-center flex-1 truncate-text">{{ result.subject }}</span>
                <span class="Paragraph-Medium">{{ computedGrade(result.marks) }}</span>
              </div>
              <div class="flex flex-column justify-content-center">
                <span class="text-center marks flex align-items-baseline justify-content-center whitespace-nowrap">
                  {{ result.marks }} <span class="Paragraph-Medium ml-2">Marks</span>
                </span>
                <span class="text-center Label truncate-text" style="min-height: 2.5em;">{{ result.examName }}</span>
                <span class="text-center Label">{{ formatToDisplayDate(result.date) }}</span>
              </div>
            </div>
          </template>
          <template #footer>
            <div class="flex justify-content-center gap-2 mt-3">
                <Button label="View Result" :class="[isInstitute ? 'yellow-button-small' : 'teal-button-small']" @click="$emit('view-result', result)" />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatToDisplayDate } from "@/utils/cleanups";
import Button from "primevue/button";
import Card from "primevue/card";
import { defineEmits, defineProps, computed } from "vue";
import { useAuthStore } from "@/stores/authStore";

defineProps({ results: Array });
defineEmits(["add-results", "view-result"]); 

const authStore = useAuthStore();
const isInstitute = computed(() => authStore.user?.role === 'institute');

const computedGrade = (marks) => {
  const m = Number(marks);
  if (isNaN(m)) return "-";
  if (m < 40) return "W";
  if (m <= 54) return "S";
  if (m <= 64) return "C";
  if (m <= 74) return "B";
  return "A";
};
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 3rem;
}
.Card {
  border-radius: 4px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.marks {
  font-size: 112px;
  font-weight: 700;
  font-family: 'Raleway', sans-serif;
  line-height: 110%;
  color: var(--black-500);
}
.truncate-text {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.teal-button-small {
    padding: 8px 16px;
    height: 30px;
    font-size: 0.75rem;
}
</style>
